<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<div class="warn-dialog">
  <div class="title">
    <p>Adicionar empresas ao grupo</p>
    <mat-icon style="cursor: pointer; color: #5f6368" (click)="onCancel()">close</mat-icon>
  </div>

  <hr />

  <div class="content">
    <!-- Conteúdo quando há empresas disponíveis -->
    <div *ngIf="empresas.data.length > 0">
      <div class="container-filtros">
        <div class="filtro-container">
          <mat-form-field appearance="outline" class="filtro">
            <mat-label>Filtro</mat-label>

            <mat-select [(value)]="filtroSelecionado" (selectionChange)="onFiltroChange()">
              <mat-option *ngFor="let filtro of opcoesfiltro" [value]="filtro.id">
                {{ filtro.nome }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Buscar</mat-label>
          <img matPrefix src="../../../../../assets/svg/icons/search.svg" alt="Lupa" class="search-icon" />
          <input matInput type="text" [placeholder]="placeholderBusca" (input)="updateFieldText($event)" />
        </mat-form-field>
      </div>

      <table mat-table [dataSource]="empresas" class="cis-default-table" matSort>
        <ng-container matColumnDef="selecionar">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let empresa">
            <mat-checkbox [checked]="empresaSelecionado(empresa)" [disabled]="empresaBloqueado(empresa)"
              (change)="alternarEmpresaSelecionada(empresa, $event.checked)"
              (click)="$event.stopPropagation()">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container *ngFor="let coluna of colunasTabela" [matColumnDef]="coluna.id">
          <th mat-header-cell class="header" *matHeaderCellDef mat-sort-header disableClear>
            {{coluna.header}}
          </th>
          <td mat-cell *matCellDef="let empresa">

            <ng-container [ngSwitch]="coluna.propriedade">
              <ng-container *ngSwitchCase="'nomeFantasia'">
                <div>
                  <div style="font-weight: bold;">{{ empresa.nomeFantasia }}</div>
                  <div style="font-size: 0.875em; color: rgba(0, 0, 0, 0.6);">{{ empresa.razaoSocial }}</div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'cnpj'">
                <span>{{ formatarCnpj(empresa.cnpj) }}</span>
              </ng-container>
              <span *ngSwitchDefault>
                {{ empresa[coluna.propriedade] }}
              </span>
            </ng-container>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
            [class.bloqueada]="empresaBloqueado(row)"
            (click)="!empresaBloqueado(row) && alternarEmpresaSelecionada(row, !empresaSelecionado(row))"></tr>
      </table>
    </div>

    <!-- Mensagem centralizada quando não há empresas disponíveis -->
    <div class="sem-dados" *ngIf="empresas.data.length === 0 && !isLoading">
      <p>Nenhuma empresa disponível para vincular ao grupo.</p>
    </div>
  </div>

  <hr />

  <div class="modal-footer" mat-dialog-actions>
    <button matButton="filled" (click)="onConfirm()">Adicionar empresas selecionadas</button>
  </div>
</div>